// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.report-layout__section {\n  margin-bottom: 1.875em;\n  padding-bottom: 1rem;\n}\n.report-layout__section:first-child {\n    margin-top: 2.875rem;\n}\n.report-layout__title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
